import { request } from '@utils';
import { LIMIT } from '@constants';

const getCustomerVehicles = async (queryParams = {}, payload = {}) => {
  if (!queryParams?.page) {
    queryParams.page = 1;
  }

  if (!queryParams?.pageSize) {
    queryParams.pageSize = LIMIT;
  }

  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/customer-vehicles/filter?${new URLSearchParams(queryParams)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getCustomerVehicleById = async (id) => {
  const results = await request.get(`/v1/customer-vehicles/${id}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEnums = async () => {
  const results = await request.get(`/v1/customer-vehicles/enums`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const createCustomerVehicle = async (payload) => {
  const body = {
    body: payload,
  };
  const results = await request.post(`/v1/customer-vehicles`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editCustomerVehicle = async (id, payload) => {
  const body = {
    body: payload,
  };
  const results = await request.patch(`/v1/customer-vehicles/${id}`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteCustomerVehicle = async (id) => {
  const results = await request.remove(`/v1/customer-vehicles/${id}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const validateByVin = async (payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(`/v1/utilities/vehicles/vin`, body);
  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getCustomerVehicleUsers = async (id, payload) => {
  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }

  const results = await request.get(
    `/v1/customer-vehicles/${id}/users`,
    payload
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const createCustomerVehicleUser = async (id, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(`/v1/customer-vehicles/${id}/users`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateCustomerVehicleUser = async (id, userId, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.patch(
    `/v1/customer-vehicles/${id}/users/${userId}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const removeCustomerVehicleUser = async (id, userId) => {
  const results = await request.remove(
    `/v1/customer-vehicles/${id}/users/${userId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBundleTypes = async (payload) => {
  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }

  const results = await request.get(`/v1/bundle-types`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const createBundleType = async (payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(`/v1/bundle-types`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBundleTypeById = async (id) => {
  const results = await request.get(`/v1/bundle-types/${id}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBundlesPricing = async (payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(`/v1/bundles/pricing`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBundles = async (payload) => {
  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }

  const results = await request.get(`/v1/bundles`, payload);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const createBundle = async (payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(`/v1/bundles`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getBundleById = async (id) => {
  const results = await request.get(`/v1/bundles/${id}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateBundle = async (id, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.patch(`/v1/bundles/${id}`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const removeBundle = async (id) => {
  const results = await request.remove(`/v1/bundles/${id}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const uploadCustomerVehiclesDocument = async (id, document, documentType) => {
  const fd = new FormData();
  fd.append('documents', document);
  fd.append('type', documentType);

  const body = {
    body: fd,
    header: {
      Accept: '*/*',
    },
  };
  const results = await request.post(
    `/v1/customer-vehicles/${id}/documents`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteCustomerVehiclesDocument = async (id, documentId) => {
  const results = await request.remove(
    `/v1/customer-vehicles/${id}/documents/${documentId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};
export {
  getCustomerVehicles,
  getCustomerVehicleById,
  getEnums,
  createCustomerVehicle,
  editCustomerVehicle,
  deleteCustomerVehicle,
  validateByVin,
  getCustomerVehicleUsers,
  createCustomerVehicleUser,
  updateCustomerVehicleUser,
  removeCustomerVehicleUser,
  getBundleTypes,
  createBundleType,
  getBundleTypeById,
  getBundlesPricing,
  getBundles,
  createBundle,
  getBundleById,
  updateBundle,
  removeBundle,
  uploadCustomerVehiclesDocument,
  deleteCustomerVehiclesDocument,
};
